__turbopack_context__.v({
  "attach": "_9ggYHW_attach",
  "audioFile": "_9ggYHW_audioFile",
  "author": "_9ggYHW_author",
  "avatar": "_9ggYHW_avatar",
  "box": "_9ggYHW_box",
  "breathe": "_9ggYHW_breathe",
  "bubble": "_9ggYHW_bubble",
  "composer": "_9ggYHW_composer",
  "content": "_9ggYHW_content",
  "countRoll": "_9ggYHW_countRoll",
  "day": "_9ggYHW_day",
  "dots": "_9ggYHW_dots",
  "emoji": "_9ggYHW_emoji",
  "emojiControl": "_9ggYHW_emojiControl",
  "emojiPopup": "_9ggYHW_emojiPopup",
  "face": "_9ggYHW_face",
  "field": "_9ggYHW_field",
  "file": "_9ggYHW_file",
  "fileName": "_9ggYHW_fileName",
  "fileSize": "_9ggYHW_fileSize",
  "fileText": "_9ggYHW_fileText",
  "gallery": "_9ggYHW_gallery",
  "gutter": "_9ggYHW_gutter",
  "image": "_9ggYHW_image",
  "inputRow": "_9ggYHW_inputRow",
  "leadingActions": "_9ggYHW_leadingActions",
  "line": "_9ggYHW_line",
  "list": "_9ggYHW_list",
  "mentionPopup": "_9ggYHW_mentionPopup",
  "meta": "_9ggYHW_meta",
  "mirror": "_9ggYHW_mirror",
  "more": "_9ggYHW_more",
  "parts": "_9ggYHW_parts",
  "pending": "_9ggYHW_pending",
  "pendingFile": "_9ggYHW_pendingFile",
  "pendingImage": "_9ggYHW_pendingImage",
  "pendingName": "_9ggYHW_pendingName",
  "pendingSize": "_9ggYHW_pendingSize",
  "picker": "_9ggYHW_picker",
  "pickerWrap": "_9ggYHW_pickerWrap",
  "pill": "_9ggYHW_pill",
  "reactButton": "_9ggYHW_reactButton",
  "reaction": "_9ggYHW_reaction",
  "reactionClip": "_9ggYHW_reactionClip",
  "reactions": "_9ggYHW_reactions",
  "reader": "_9ggYHW_reader",
  "readers": "_9ggYHW_readers",
  "receipts": "_9ggYHW_receipts",
  "remove": "_9ggYHW_remove",
  "retry": "_9ggYHW_retry",
  "root": "_9ggYHW_root",
  "row": "_9ggYHW_row",
  "scroller": "_9ggYHW_scroller",
  "send": "_9ggYHW_send",
  "sendIcon": "_9ggYHW_sendIcon",
  "srOnly": "_9ggYHW_srOnly",
  "stack": "_9ggYHW_stack",
  "status": "_9ggYHW_status",
  "textarea": "_9ggYHW_textarea",
  "track": "_9ggYHW_track",
  "tray": "_9ggYHW_tray",
  "trayClip": "_9ggYHW_trayClip",
  "typing": "_9ggYHW_typing",
  "viewport": "_9ggYHW_viewport",
});
